import React, { Component } from 'react'
import aboutus from '../../images/aboutproject-main.webp'
import SuccessSvg from '../icons/SuccessSvg'
import SectionHeader from './SectionHeader'

export class AboutMP extends Component {
    render() {
        return (
            <section className='container flex gap-[40px]  p-[52px_0px] max-[1101px]:pt-[32px]  max-[1101px]:pb-[40px] max-[1001px]:flex-col-reverse max-[1001px]:items-center'>
                <div className='max-w-1/2'>
                    <img src={aboutus} className='max-w-1/2 max-h-[485px] max-[1001px]:max-h-[380px]' />
                </div>

                <div className='flex flex-col gap-[35px] items-start max-w-[50%] max-[1101px]:gap-[25px] max-[1001px]:max-w-[90%]'>
                    <div className='flex flex-col gap-[15px] items-start max-[1101px]:gap-[10px]'>
                        <div className='flex flex-col items-start gap-[5px]'>
                            <span className='text-[var(--orange)]'>Peşəkarlıq və Yaradıcılıq Bir Arada</span>

                            <SectionHeader title='Haqqımızda' />
                        </div>


                        <p className='text-[16px] text-[#555] font-[400] max-[1101px]:text-[14px]'>
                            Bizim komandamız hər zaman müştəriləri üçün ən müasir və effektiv həlləri təklif edir. Sizə unikal web dizayn və texnoloji həllər lazımdırsa, doğru yerdəsiniz! Biz işimizdə peşəkarıq və sizinlə uzunmüddətli əməkdaşlıq üçün buradayıq.
                        </p>

                        <p className='text-[16px] text-[#555] font-[400] max-[1101px]:text-[14px]'>
                            Sizə hər zaman yüksək keyfiyyət və etibarlılıq vəd edirik. Biz sizin uğurunuzu öz uğurumuz kimi görürük.
                        </p>
                    </div>

                    <div className='flex flex-col gap-[15px] max-[1101px]:gap-[10px] max-[1001px]:items-center  '>
                        <div className='flex items-center gap-[12px] max-[350px]:gap-[8px] '>
                            <span className='rounded-[50px]'><SuccessSvg /></span>
                            <p className='font-[600] text-[18px] max-[1101px]:text-[16px] max-[350px]:text-[14px] max-[350px]:font-[500]'>Sizə hər zaman yüksək keyfiyyət və etibarlılıq vəd edirik.</p>
                        </div>
                        <div className='flex items-center gap-[12px] max-[350px]:gap-[8px]'>
                            <span className='rounded-[50px]'><SuccessSvg /></span>
                            <p className='font-[600] text-[18px] max-[1101px]:text-[16px] max-[350px]:text-[14px] max-[350px]:font-[500]'>Layihənizi vaxtında və istədiyiniz kimi təhvil verəcəyimizə zəmanət veririk.</p>
                        </div>
                        <div className='flex items-center gap-[12px] max-[350px]:gap-[8px]'>
                            <span className='rounded-[50px]'><SuccessSvg /></span>
                            <p className='font-[600] text-[18px] max-[1101px]:text-[16px] max-[350px]:text-[14px] max-[350px]:font-[500]'>Uğurunuz bizim prioritetimizdir – sizin məmnuniyyətinizə fokuslanırıq.</p>
                        </div>

                    </div>

                </div>
            </section>
        )
    }
}

export default AboutMP